// Shared favorite (heart) button logic, used both by the vanilla card partials
// (_advertisement.html.erb, _user_advertisement.html.erb) via delegated click
// handling below, and directly by CarGallery.vue on the advertisement detail page.

import { Modal } from 'bootstrap'

function getCsrfToken() {
  const element = document.querySelector('[name="csrf-token"]')
  return element ? element.content : ''
}

export function isUserSignedIn() {
  return document.body.dataset.userSignedIn === 'true'
}

export function showFavoriteSignInModal() {
  const modalEl = document.getElementById('favorite-not-signed-in-modal')
  if (!modalEl) return
  new Modal(modalEl).show()
}

// Toggles the favorite state for an advertisement on the server and resolves
// with the new state. Throws if the request fails.
export async function toggleFavorite(advertisementId, currentlyFavorited) {
  const url = currentlyFavorited ? `/api/v1/favorites/${advertisementId}` : '/api/v1/favorites'
  const response = await fetch(url, {
    method: currentlyFavorited ? 'DELETE' : 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: currentlyFavorited ? undefined : JSON.stringify({ advertisement_id: advertisementId }),
  })

  if (!response.ok) throw new Error(`Favorite toggle failed with status ${response.status}`)

  const data = await response.json()
  return data.favorited
}

const FAVORITE_CARD_FADE_MS = 250

function removeFavoriteCard(card) {
  const countEl = document.querySelector('[data-favorites-count]')
  if (countEl) countEl.textContent = Math.max(0, parseInt(countEl.textContent, 10) - 1)

  card.style.transition = `opacity ${FAVORITE_CARD_FADE_MS}ms ease`
  card.style.opacity = '0'
  setTimeout(() => card.remove(), FAVORITE_CARD_FADE_MS)
}

export const FavoriteButton = {
  initialized: false,

  init() {
    if (this.initialized) return
    this.initialized = true
    document.addEventListener('click', (event) => this.handleClick(event))
  },

  handleClick(event) {
    const button = event.target.closest('.car-card__favorite')
    if (!button) return

    event.preventDefault()
    event.stopPropagation()

    if (!isUserSignedIn()) {
      showFavoriteSignInModal()
      return
    }

    this.toggle(button)
  },

  toggle(button) {
    if (button.disabled) return
    const advertisementId = button.dataset.advertisementId
    if (!advertisementId) return

    const wasActive = button.classList.contains('active')
    button.disabled = true

    toggleFavorite(advertisementId, wasActive)
      .then((favorited) => {
        button.classList.toggle('active', favorited)

        if (!favorited) {
          const card = button.closest('[data-favorites-list] > div')
          if (card) removeFavoriteCard(card)
        }
      })
      .catch(() => {
        // Network/server error - leave the button state unchanged, just unlock it.
      })
      .finally(() => {
        button.disabled = false
      })
  },
}
